export enum DependencyLicenseEndpoint {
  Base = '/assets/licenses/licenses.json',
}
